<template>
    <div>
        <div v-if="fetchedStartFolders == null" class="d-flex justify-content-center mb-3">
            <b-spinner>*** {{ foldersLoading }} ***</b-spinner>
        </div>
        <div style="padding-top: 32px;"></div>
        <b-card v-if="fetchedStartFolders != null" header="Tillgängliga gallerier" class="subfolder-list">
            <div style="display: flex; flex-wrap: wrap;">
                <div v-for="myfolder in fetchedStartFolders.startFolders" v-bind:key="myfolder.displayName">
                <b-list-group v-bind:horizontal="!mobileLayout">
                    <b-list-group-item
                        :href="`#/gallery/#${myfolder.path}`">
                        
                            <!--<a v-on:click="fetchFolderList(myfolder.displayName)" :href="`#${myfolder.displayName.replace(/[^a-z]+/i,'-').toLowerCase()}`">{{ myfolder.displayName }}</a>-->
                            <!--a :href="`#/gallery/#${myfolder.path}`">{{ myfolder.displayName }}</a>-->
                            {{ myfolder.displayName }}
                            <!--<router-link :to="fetchedFolder.path + myfolder.displayName">{{ myfolder.displayName }}</router-link>-->
                    </b-list-group-item>
                </b-list-group>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
// Import Axios so that we can perform REST calls to the video-streamer-server back-end.
import axios from 'axios';
//import {globalStore} from '../main.js'

    export default {
        name: 'StartFolders',
        data() {
            return {
                currentPath: [""], //string[] = [""],
                foldersLoading: "Loading folders", //string = "No folders yet", //this.fetchFolderList("");
                fetchedStartFolders: null, // = null,
                loadedToken: null,
                windowWidth: window.innerWidth,
                computedLayout: 'grid-container',
                computedLayoutElement: 'video33',
                computedVideoLayout: 'video',
                mobileLayout: false,

                // This is the hostname part of the URL to the repo-list-server backend. The back-end normally
                // runs in a JBoss Wildfly somewhere.
                // While developing, it might be desirable to run the back-end on localhost in which case you
                // might get a port collision if both the Wildfly and the webpack-dev-server wants to run on
                // port 8080. But it turns out, the webpack-dev-server will automatically use 8081 if 8080 is
                // in use. So when developing and running everything locally, do as follows:
                // 1. Start the Wildfly with the repo-list-server back-end normally on port 8080.
                // 2. Run the webpack-dev-server normally with "npm run serve" and it will use 8081.
                // 3. Open http://localhost:8081/
                // 
                // The host part of the URL to the back-end has been made configurable via an environment variable:
                //      VUE_APP_BACK_END_HOST_URL
                // An environment variable's value can be obtained through process.env.<environment-variable-name>.
                // For environment variables to work, @vue/cli requires all the variables to be defined in files
                // called ".env" or "env.<mode>" in the root of the project. I.e. the files must begin with ".env"
                // and "<something>.env" will not work. The <mode> part can be either "development" or "production"
                // and specifies in which mode they will be used. Thus, it is possible to provide different values
                // for different run modes.
                // E.g. sample values for this variable in different modes would be:
                // mode development (file .env): VUE_APP_BACK_END_HOST_URL=http://localhost:8080
                // mode production: (file .env.production) VUE_APP_BACK_END_HOST_URL=https://hem.fomalhaut.se
                serverUrl: "<undefined>", //string = "<undefined>";

            }
        },

        /*
         *  Method that is called right after an instance has been created.
         */
        created() {
            //alert("Ceated." /*+ this.$route.hash*/);
            //this.fetchFolderList("");
            this.fetchData()
        },

        /*mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth
                if(this.windowWidth < 735) {
                    this.mobileLayout = true;
                    globalStore.mobileMode = true;
                    this.computedLayout = 'grid-container_mobile';
                    this.computedLayoutElement = 'video33_mobile';
                    this.computedVideoLayout = 'video_mobile';
                } else {
                    this.mobileLayout = false;
                    globalStore.mobileMode = false;
                    this.computedLayout = 'grid-container';
                    this.computedLayoutElement = 'video33';
                    this.computedVideoLayout = 'video';
                }
            }
        },*/

        /*watch: {
            // call again the method if the route changes
            '$route': 'fetchData'
        },*/

        methods: {
            fetchData() {
                //alert("Hash: " + this.$route.hash);
                //var folderPath = this.$route.hash.substring(1, this.$route.hash.length);
                this.fetchStartFolderList();
                //this.fetchedStartFolders = ["/Super8/Stockholm", "/Testfiler"]
            },

            fetchStartFolderList() {
                //alert("Fetching folders from folderPath: " + folderPath);
                this.foldersLoading = "Startfolders loading";
                this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;
                //alert("serverUrl: " + this.serverUrl);
                //alert("StartFolders LS ott: " + localStorage.ott);
                //axios.get(this.serverUrl + "/video-streamer-server-context-root/video-streamer-server-application-path/rest/v1/folders/" + this.currentPath.join("/") + "/" + subFolderName, {

                const queryString = window.location.search;
                console.log(queryString);
                const urlParams = new URLSearchParams(queryString);
                const ott = urlParams.get('ott');
                const oneTimeTokenQueryParamString = ott? "?One-Time-Token=" + ott: "";

                this.$auth.getTokenSilently().then((token) => {
                    this.loadedToken = token;
                    axios.get(this.serverUrl + "/video-streamer-server/rest/v2/start-folders" + oneTimeTokenQueryParamString, {
                        headers: {
                            //Authorization: `Bearer ${this.jwtToken}`    // send the access token through the 'Authorization' header
                            //'X-JWT-Assertion': '${this.jwtToken}'
                            'X-JWT-Assertion': `${token}`
                        }
                    }).then((response) => {
                        //this.loading = false;
                        //this.fetchedRepos = response.data.repos;
                        //alert("Called rest folders ok:" + response.data);
                        //if (subFolderName != "") this.currentPath.push(subFolderName);
                        //this.fetchedSubfolders = response.data.folders;
                        this.fetchedStartFolders = response.data;
                        //alert("Fetched folders from folderPath: " + this.fetchedFolder.folders);
                        //this.videosLoading = this.fetchVideoList();
                        return "OK"
                    }, (error) => {
                        //this.loading = false;
                        alert("Failed to get start folders: " + error); // Problem with JWT token start time?
                        return "Error"
                    })
                }, (error) => {
                        axios.get(this.serverUrl + "/video-streamer-server/rest/v2/start-folders?One-Time-Token=" + ott, {
                    }).then((response) => {
                        this.fetchedStartFolders = response.data;
                        return "OK"
                    }, (error) => {
                        //this.loading = false;
                        alert(error)
                        return "Error"
                    })

                    //console.log("No token could be fetched from Auth0: " + error + ". Redirecting to login prompt");
                    //this.$auth.loginWithRedirect();
                })
                return "Startfolders not finished yet"
            },
        }
    }
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#breadcrumb {
    color: #ff3eff;
}
.fixed_header {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    top: 0px; /* top left corner should start at topmost spot */
    width: 100vw; /* take up the full browser width */
    z-index: 201; /* high z index so other content scrolls underneath */
    height: 25px; /* define height for content */
}

.grid-container_mobile {
    background-color: black;
    //display: grid;
    //grid-auto-flow: row;
}

.grid-container {
    //border: 1px;
    width: 100%;
    background-color: black;
    /*display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0px;
    grid-auto-flow: column;*/
    /*grid-auto-rows: minmax(100px, auto);
    grid-template-rows: repeat(auto-fill, 100px);
  grid-template-columns: repeat(auto-fill, 100px);
  grid-auto-columns: 100px;
  grid-auto-rows: 100px;*/
}

.caption {
    margin-top: 5px;
}

.video_mobile {
    width: 100%;
}

.video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.video33_mobile {
    //border: 1px solid red;
    display: block;
}

.video33 {
    //border: 1px solid red;
    //display: block;
    float: left;
    width: 320px; height: 320px;
    padding: 20px;
    
    //margin-left: auto;
    //margin-right: auto;
    //object-fit: cover;
}
.video50 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: 100%;
}
.video100 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
}
</style>
